export default {
  root: {
    marginBottom: 4,
  },
}
